/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {CatalogItemId, NoteId, NoteInput} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getAddServiceNoteUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/services/${id}/notes`;
};

/**
 * @summary Add service note
 */
export const addServiceNote = async (
  id: CatalogItemId,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<NoteId> => {
  return customFetch<NoteId>(getAddServiceNoteUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};

export const getEditServiceNoteUrl = (id: CatalogItemId, noteId: NoteId) => {
  return `/api/v1/engineering/services/${id}/notes/${noteId}`;
};

/**
 * @summary Edit service note
 */
export const editServiceNote = async (
  id: CatalogItemId,
  noteId: NoteId,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditServiceNoteUrl(id, noteId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};

export const getRemoveServiceNoteUrl = (id: CatalogItemId, noteId: NoteId) => {
  return `/api/v1/engineering/services/${id}/notes/${noteId}`;
};

/**
 * @summary Remove service note
 */
export const removeServiceNote = async (
  id: CatalogItemId,
  noteId: NoteId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveServiceNoteUrl(id, noteId), {
    ...options,
    method: "DELETE",
  });
};
